import { DateHelper } from "utils/helpers";

const toDay = (date: Date | string): Date => DateHelper.resetTime(new Date(date)) as Date;

// Stricter than Core's IsEmploymentDateChangeAllowed, which already accepts the end date itself. On
// that day Wint.Salary still reports the old employment as active, so Core would rewrite the old
// employment instead of creating a new one.
export const isEmploymentEnded = (endDate: Date | string | undefined, today: Date = DateHelper.today()): boolean =>
  !!endDate && toDay(endDate) < toDay(today);

// Strictly after the old end date: Core accepts the end date itself, but that day would then be
// covered by both the old and the new employment.
export const isRehireStartDate = (
  startDate: Date | string | undefined,
  previousEndDate: Date | string | undefined
): boolean =>
  !!startDate &&
  !!previousEndDate &&
  DateHelper.isValidDate(new Date(startDate)) &&
  toDay(startDate) > toDay(previousEndDate);

export const isSameDay = (a: Date | string | undefined, b: Date | string | undefined): boolean =>
  !!a && !!b && toDay(a).getTime() === toDay(b).getTime();
